import React from 'react'
import PropTypes from 'prop-types'
import { ListGrid } from 'components/organisms'
import { contentTypesNames } from 'interfaces/contentTypeInterface'
import * as S from './styled'

const RenderRelatedContent = ({ contentType, content, items }) => (
  <S.RelatedContentContainer>
    <S.RelatedTitle>Additional {contentTypesNames(contentType, true)}</S.RelatedTitle>
    <ListGrid items={items} content={content} related itemHeight='225px' contentType={contentType} />
  </S.RelatedContentContainer>
)

RenderRelatedContent.defaultProps = {}

RenderRelatedContent.propTypes = {
  items: PropTypes.array.isRequired,
  content: PropTypes.object.isRequired,
  contentType: PropTypes.string.isRequired,
}

export default RenderRelatedContent
